import { CertificateScopeType, CertificateStatusType } from '../enums'
import { Certificate } from '../types'

export const getReviewAllowed = ({
  personal,
  certificate,
  hasManageCertificatesTenantScopePermission,
  hasManageCertificatesGlobalScopePermission,
}: {
  personal: boolean
  certificate?: Certificate | null
  hasManageCertificatesTenantScopePermission: boolean
  hasManageCertificatesGlobalScopePermission: boolean
}) => {
  if (personal || !certificate) {
    return false
  }

  if (certificate.StatusId !== CertificateStatusType.PendingReview) {
    return false
  }

  switch (certificate.ScopeId) {
    case CertificateScopeType.TenantCertificate:
      return hasManageCertificatesGlobalScopePermission
    case CertificateScopeType.UserCertificate:
    case CertificateScopeType.ProfileCertificate:
      return hasManageCertificatesTenantScopePermission
    default:
      return false
  }
}
